module.exports = __webpack_public_path__ + "img/Comment_ca_marche_3.1f40408b.webp";